import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./damageColumns";

export function DamageTablePage() {
  return (
    <ServerDataGrid
      initialStateOverride={{
        filter: {
          filterModel: {
            items: [{ field: "damage.damage_qty", operator: ">", value: 0 }],
          },
        },
      }}
      columns={columns}
      getRowId={(row) => row.damage.id}
      apiEndpoint="/datagrid/damage"
      tableName="damage"
      enableCreate={false}
      enableSearch={true}
    />
  );
}
